export default __webpack_public_path__ + "static/kurorty-img-6-ab99ebd5e0ab6c0b96368b2c0c092236.png";